module.exports = __webpack_public_path__ + "files/021f22ae71d8a61c196ecad590f5d997.png";